<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-xl-6">
        <div class="card" v-if="action">
          <div class="card-header">
            {{action.submission_complete_heading}}
          </div>
          <div class="card-body">
            <form>
              <p>
                {{action.submission_complete_details}}
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/lib/api'

export default {
  name: 'SubmissionComplete',
  data () {
    return {
      workflowId: parseInt(this.$route.query.w),
      actionId: this.$route.query.a,
      workflow: null
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetchWorkflow()
    }
  },
  computed: {
    action () {
      if (this.workflow != null) {
        var actions = this.getAllActions(this.workflow)
        console.log(actions)
        return actions.find((action) => { return action.id === this.actionId })
      } else {
        return null
      }
    }
  },
  mounted () {
    this.fetchWorkflow()
  },
  methods: {
    fetchWorkflow () {
      this.hasError = false
      API.get(`/workflows/${this.workflowId}`, {}, this.$store.getters.authHeaders)
        .then((response) => {
          this.workflow = response.data
        })
    },
    getAllActions (parentAction) {
      var actions = []
      if (parentAction.choices != null) {
        parentAction.choices.forEach((choice) => {
          actions.push(choice)
          this.getAllActions(choice).forEach((choice) => {
            actions.push(choice)
          })
        })
      }
      return actions
    },
    redoLink () {
      return null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/SubmissionComplete.vue